import { 健康保険被保険者区分 } from "./types";

export function calculate月間健康保険料(
  区分: 健康保険被保険者区分,
  標準報酬月額: number, // 会社員用
  前年の合計所得: number, // 自営業用
  健康保険料率: number, // 協会けんぽ等用（例: 0.10）
  国保_均等割額: number, // 市区町村ごとに違う定額料金
  国保_所得割率: number, // 市区町村ごとに違う率
): number {

  let 月間健康保険料: number = 0;
  
  // 3. 区分ごとの計算ロジック
  switch (区分) {
    // 1. 月末時点で, 生活保護を受けている人や住民票が日本にはない人
    case "被保険者ではない":
      月間健康保険料 = 0;
      
    // 2. 75歳以上の絶対ルール（最優先で弾く）
    case "後期高齢者":
      月間健康保険料 = calculate後期高齢者用の月間健康保険料(); // 役所へ直接払う

    // 3. 会社員
    case '協会けんぽ':
    case '健康保険組合':
      月間健康保険料 = Math.floor((標準報酬月額 * 健康保険料率) / 2);

    // 4. 自営業
    case '国民健康保険':
      // 【フリーランス】(所得 - 基礎控除43万) × 所得割率 ＋ 均等割額
      // ※国保は「世帯単位」で年額計算し、月割り（10回払い等）にするのが一般的です。
      const 基礎控除後所得 = Math.max(0, 前年の合計所得 - 430000);
      const 年間国保料 = Math.floor(基礎控除後所得 * 国保_所得割率) + 国保_均等割額;
      // 月間（12ヶ月で均した概算）として返す場合
      月間健康保険料 = Math.floor(年間国保料 / 12); 

    // 5. 会社員の被扶養者
    case '被扶養者':
      月間健康保険料 = 0;
  }

  return 月間健康保険料;
}

function calculate後期高齢者用の月間健康保険料(){
  return 0;
}